import { render, staticRenderFns } from "./banner-add-or-update.vue?vue&type=template&id=2546bf27&"
import script from "./banner-add-or-update.vue?vue&type=script&lang=js&"
export * from "./banner-add-or-update.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports